export default __webpack_public_path__ + "static/media/4.1d75f5d6.png";